<template>
  <div class="tabs" :class="scrollArrowsClass" ref="tabs" v-resize="handleResize">
    <div v-bar="{ horizontal: true }" class="tabs__inner" ref="tabs-inner">
      <div ref="tabs-inner-list" v-scroll-el="handleHorizontalScroll">
        <ul class="tabs__list">
          <li v-for="(item, index) in items" class="tabs__item" :key="index">
            <NuxtLink
              :to="`${corePath}${item.nodeId}/`"
              class="tabs__link label"
              active-class="tabs__link_active"
              @click="checkTabChangeState(`${corePath}${item.nodeId}/`)"
            >
              {{ setProperFieldExternalFirst(item, 'title') }}
            </NuxtLink>
          </li>
          <li>
            <div class="tabs__filler">&nbsp;</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="tabs__arrow tabs__arrow_left" :class="{ tabs__arrow_hidden: isLeftArrowHidden }">
      <span class="icon-arrow-next-small" @click="scrollToPrevTab"></span>
    </div>
    <div class="tabs__arrow tabs__arrow_right" :class="{ tabs__arrow_hidden: isRightArrowHidden }" ref="tabs-arrow">
      <span class="icon-arrow-next-small" @click="scrollToNextTab"></span>
    </div>
  </div>
</template>

<script>
  import { useMainStore } from '@/stores/main';
  import { storeToRefs } from 'pinia';

  export default {
    data() {
      return {
        scrollArrowsClass: '',
        tabsInnerClientWidth: 0,
        tabsInnerScrollWidth: 0,
        scrollLeftPosition: 0
      };
    },
    computed: {
      tabsInner() {
        return this.$refs['tabs-inner'];
      },
      tabs() {
        return this.$refs['tabs'];
      },
      tabsInnerList() {
        return this.$refs['tabs-inner-list'];
      },
      isScrollArrowsVisible() {
        if (!this.tabsInner || !this.tabsInnerList) return false;
        return this.tabsInner.clientWidth < this.tabsInner.scrollWidth;
      },
      isLeftArrowHidden() {
        return this.scrollLeftPosition == 0;
      },
      isRightArrowHidden() {
        return this.scrollLeftPosition + this.tabsInnerClientWidth >= this.tabsInnerScrollWidth - 1;
      },
      scrollPadding() {
        return this.$refs['tabs-arrow'] ? this.$refs['tabs-arrow'].clientWidth : 0;
      }
    },
    methods: {
      checkTabChangeState(url) {
        // Use Pinia store action
        const mainStore = useMainStore();
        const normalize = (p) =>
          String(p || '')
            .split('?')[0]
            .replace(/\/+$/, '');
        const current = normalize(this.$route && this.$route.path);
        const target = normalize(url);
        mainStore.setTabChangeState(current !== target);
      },
      scrollToPrevTab() {
        if (!this.tabsInner) return;
        const currentScroll = this.tabsInner.scrollLeft;
        if (currentScroll <= 0) return;
        this.sideScroll(this.tabsInner, 'left', 1, currentScroll, 5);
        this.scrollLeftPosition = 0;
      },
      scrollToNextTab() {
        if (!this.tabsInner) return;
        const maxScroll = Math.max(this.tabsInnerScrollWidth - this.tabsInnerClientWidth, 0);
        const currentScroll = this.tabsInner.scrollLeft;
        const distance = maxScroll - currentScroll;
        if (distance <= 0) return;
        this.sideScroll(this.tabsInner, 'right', 1, distance, 5);
        this.scrollLeftPosition += distance;
      },
      sideScroll(el, direction, speed, distance, step) {
        this.scrollArrowsClass = 'tabs_with-arrows tabs_scrolling';
        let scrollAmount = 0;
        let slideTimer = setInterval(() => {
          if (direction == 'left') {
            el.scrollLeft -= step;
          } else {
            el.scrollLeft += step;
          }
          scrollAmount += step;
          if (scrollAmount >= distance - step) step = 1;
          if (scrollAmount >= distance) {
            this.scrollArrowsClass = 'tabs_with-arrows';
            if (direction == 'left') {
              el.scrollLeft = 0;
            }
            window.clearInterval(slideTimer);
          }
        }, speed);
      },
      handleResize() {
        if (!this.tabsInner || !this.tabsInnerList) return;
        this.tabsInnerClientWidth = this.tabsInner.clientWidth;
        this.tabsInnerScrollWidth = this.tabsInner.scrollWidth;
        if (this.isScrollArrowsVisible) {
          this.scrollArrowsClass = 'tabs_with-arrows';
        } else {
          this.scrollArrowsClass = '';
        }
      },
      handleHorizontalScroll() {
        this.scrollLeftPosition = this.tabsInner.scrollLeft;
        this.tabsInnerScrollWidth = this.tabsInner.scrollWidth;
      }
    },
    mounted() {
      if (!this.tabsInner || !this.tabsInnerList) return;
      this.tabsInnerClientWidth = this.tabsInner.clientWidth;
      this.tabsInnerScrollWidth = this.tabsInner.scrollWidth;
      if (this.isScrollArrowsVisible) this.scrollArrowsClass = 'tabs_with-arrows';
    },
    updated() {
      this.tabsInnerScrollWidth = this.tabsInner.scrollWidth;
    },
    props: {
      items: {
        default() {
          return [];
        },
        type: Array
      },
      corePath: {
        default: '',
        type: String
      }
    }
  };
</script>
